let Navigation = {
    init: () => {
        handleNavDropdown();
        handleSideNavDropdown();
        handleBurgerClick();
        handleLogout();
    }
};

const handleNavDropdown = () => {
    let navDropdownLink = $('.nav-item-dropdown'),
        nav = $('nav'),
        header = $('.header');

    navDropdownLink.each(function () {
        $(this).on('click', function (e) {
            let $this = $(this),
                $target = $(e.target);

            if ($target.hasClass('nav-item-notification') || $.grep($target.parents(), (item) => $(item).hasClass('nav-item-notification')).length) return;

            if ($target.hasClass('nav-item-link')) e.preventDefault();

            if (!$this.find('.nav-account').length) header.addClass('header-dropdown-open');

            $this.hasClass('dropdown-open') ? header.removeClass('header-dropdown-open') : $('.dropdown-open').removeClass('dropdown-open');

            $target.hasClass('nav-item-link-language') ? nav.addClass("p-relative") : nav.removeClass("p-relative");

            $this.toggleClass('dropdown-open');

        });
    });

    $('body').on('click', (e) => {
        let target = $(e.target),
            scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (target.hasClass('nav-item-link')) return;

        if (header.hasClass('header-dropdown-open')) {
            header.removeClass('header-dropdown-open');

            if (scrollTop !== 0) {
                if (header.hasClass('header-with-banner') ? header.addClass('header-hide-with-banner') : header.addClass('header-hide'));
            }

            $('.nav-item-dropdown.dropdown-open').removeClass('dropdown-open');
        }
    })
};

const handleSideNavDropdown = () => {
    let $sideMenuLink = $('.nav-sidebar-link');

    $sideMenuLink.on('click', function () {
        let $data = $(this).data('dropdown');
        $(this).toggleClass('active');
        if ($data) $('.nav-sidebar-dropdown[data-dropdown="' + $data + '"]').toggleClass('is-open');
    });
};

const handleBurgerClick = () => {
    $('.nav-button-burger').on('click', function () {
        let $this = $(this);
        $this.attr('aria-pressed') === 'true' ? $this.attr('aria-pressed', 'false') : $this.attr('aria-pressed', 'true');
        $('body').toggleClass('m-sidebar');
        $('.nav-sidebar-sidemenu').removeClass('is-open');
    });
};

const handleLogout = () => {
    $('[data-bind="logout"]').on('click', (e) => {
        e.preventDefault();
        //clear freshchat userdata
        if (typeof window.fcWidget !== 'undefined') {
            window.fcWidget.user.clear();
        }
        //logout
        $('[data-bind="logoutForm"]').submit();
    });
};

export default Navigation;
